import React from 'react'
import styled from 'styled-components'

const IconContainer = styled.div`
  justify-content: center;
  align-items: center;
  display: flex;
  height:  75px;  
`

const ChartStackedLineIcon = () => (
  <IconContainer>
    <svg xmlns="http://www.w3.org/2000/svg" width="85.47" height="69.029" viewBox="0 0 85.47 69.029">
      <g id="stacked_line" transform="translate(-457.275 -192.408)">
        <g id="Groupe_3793" dataname="Groupe 3793">
          <path id="Tracé_4416" dataname="Tracé 4416" d="M10765.091,8461.09l28.486-34.137,20.346,8.465,31.007-37.727" transform="translate(-10304.999 -8202.469)" fill="none" stroke="currentColor" strokeLinecap="round" strokeWidth="4"/>
          <path id="Tracé_4417" dataname="Tracé 4417" d="M10767.2,8444.621l28.609-12.835,20.194,6.524,30.771-19.152" transform="translate(-10307.11 -8186)" fill="none" stroke="currentColor" strokeLinecap="round" strokeWidth="4"/>
          <line id="Ligne_462" dataname="Ligne 462" x1="81" transform="translate(459.5 260.065)" fill="none" stroke="currentColor" strokeLinecap="round" strokeWidth="1"/>
          <g id="Ellipse_1615" dataname="Ellipse 1615" transform="translate(479 242)" fill="#fff" stroke="currentColor" strokeWidth="1">
            <circle cx="1" cy="1" r="1" stroke="none"/>
            <circle cx="1" cy="1" r="0.5" fill="none"/>
          </g>
          <g id="Ellipse_1616" dataname="Ellipse 1616" transform="translate(488 237)" fill="#fff" stroke="currentColor" strokeWidth="1">
            <circle cx="1" cy="1" r="1" stroke="none"/>
            <circle cx="1" cy="1" r="0.5" fill="none"/>
          </g>
          <g id="Ellipse_1617" dataname="Ellipse 1617" transform="translate(494 243)" fill="#fff" stroke="currentColor" strokeWidth="1">
            <circle cx="1" cy="1" r="1" stroke="none"/>
            <circle cx="1" cy="1" r="0.5" fill="none"/>
          </g>
          <g id="Ellipse_1618" dataname="Ellipse 1618" transform="translate(500 238)" fill="#fff" stroke="currentColor" strokeWidth="1">
            <circle cx="1" cy="1" r="1" stroke="none"/>
            <circle cx="1" cy="1" r="0.5" fill="none"/>
          </g>
          <g id="Ellipse_1620" dataname="Ellipse 1620" transform="translate(507 243)" fill="#fff" stroke="currentColor" strokeWidth="1">
            <circle cx="1" cy="1" r="1" stroke="none"/>
            <circle cx="1" cy="1" r="0.5" fill="none"/>
          </g>
          <g id="Ellipse_1621" dataname="Ellipse 1621" transform="translate(513 238)" fill="#fff" stroke="currentColor" strokeWidth="1">
            <circle cx="1" cy="1" r="1" stroke="none"/>
            <circle cx="1" cy="1" r="0.5" fill="none"/>
          </g>
          <g id="Ellipse_1622" dataname="Ellipse 1622" transform="translate(518 231)" fill="#fff" stroke="currentColor" strokeWidth="1">
            <circle cx="1" cy="1" r="1" stroke="none"/>
            <circle cx="1" cy="1" r="0.5" fill="none"/>
          </g>
          <g id="Ellipse_1623" dataname="Ellipse 1623" transform="translate(523 238)" fill="#fff" stroke="currentColor" strokeWidth="1">
            <circle cx="1" cy="1" r="1" stroke="none"/>
            <circle cx="1" cy="1" r="0.5" fill="none"/>
          </g>
          <g id="Ellipse_1624" dataname="Ellipse 1624" transform="translate(529 231)" fill="#fff" stroke="currentColor" strokeWidth="1">
            <circle cx="1" cy="1" r="1" stroke="none"/>
            <circle cx="1" cy="1" r="0.5" fill="none"/>
          </g>
          <g id="Ellipse_1625" dataname="Ellipse 1625" transform="translate(523 223)" fill="#fff" stroke="currentColor" strokeWidth="1">
            <circle cx="1" cy="1" r="1" stroke="none"/>
            <circle cx="1" cy="1" r="0.5" fill="none"/>
          </g>
          <g id="Ellipse_1627" dataname="Ellipse 1627" transform="translate(529 216)" fill="#fff" stroke="currentColor" strokeWidth="1">
            <circle cx="1" cy="1" r="1" stroke="none"/>
            <circle cx="1" cy="1" r="0.5" fill="none"/>
          </g>
          <g id="Ellipse_1628" dataname="Ellipse 1628" transform="translate(538 216)" fill="#fff" stroke="currentColor" strokeWidth="1">
            <circle cx="1" cy="1" r="1" stroke="none"/>
            <circle cx="1" cy="1" r="0.5" fill="none"/>
          </g>
          <g id="Ellipse_1629" dataname="Ellipse 1629" transform="translate(534 209)" fill="#fff" stroke="currentColor" strokeWidth="1">
            <circle cx="1" cy="1" r="1" stroke="none"/>
            <circle cx="1" cy="1" r="0.5" fill="none"/>
          </g>
          <g id="Ellipse_1626" dataname="Ellipse 1626" transform="translate(534 223)" fill="#fff" stroke="currentColor" strokeWidth="1">
            <circle cx="1" cy="1" r="1" stroke="none"/>
            <circle cx="1" cy="1" r="0.5" fill="none"/>
          </g>
          <g id="Ellipse_1619" dataname="Ellipse 1619" transform="translate(494 231)" fill="#fff" stroke="currentColor" strokeWidth="1">
            <circle cx="1" cy="1" r="1" stroke="none"/>
            <circle cx="1" cy="1" r="0.5" fill="none"/>
          </g>
          <g id="Groupe_3794" dataname="Groupe 3794">
            <line id="Ligne_463" dataname="Ligne 463" y1="8.565" x2="6" transform="translate(470.5 251.5)" fill="none" stroke="currentColor" strokeLinecap="round" strokeWidth="1"/>
            <line id="Ligne_472" dataname="Ligne 472" y1="8.565" x2="6" transform="translate(535.5 251.5)" fill="none" stroke="currentColor" strokeLinecap="round" strokeWidth="1"/>
            <line id="Ligne_468" dataname="Ligne 468" y1="8.565" x2="6" transform="translate(507.5 251.5)" fill="none" stroke="currentColor" strokeLinecap="round" strokeWidth="1"/>
            <line id="Ligne_464" dataname="Ligne 464" y1="11.565" x2="8" transform="translate(476.5 248.5)" fill="none" stroke="currentColor" strokeLinecap="round" strokeWidth="1"/>
            <line id="Ligne_466" dataname="Ligne 466" y1="11.565" x2="8" transform="translate(491.5 248.5)" fill="none" stroke="currentColor" strokeLinecap="round" strokeWidth="1"/>
            <line id="Ligne_467" dataname="Ligne 467" y1="9.565" x2="6.621" transform="translate(499.879 250.5)" fill="none" stroke="currentColor" strokeLinecap="round" strokeWidth="1"/>
            <line id="Ligne_470" dataname="Ligne 470" y1="24.565" x2="16.811" transform="translate(521.689 235.5)" fill="none" stroke="currentColor" strokeLinecap="round" strokeWidth="1"/>
            <line id="Ligne_465" dataname="Ligne 465" y1="11.565" x2="8" transform="translate(483.5 248.5)" fill="none" stroke="currentColor" strokeLinecap="round" strokeWidth="1"/>
            <line id="Ligne_469" dataname="Ligne 469" y1="17.565" x2="12" transform="translate(514.5 242.5)" fill="none" stroke="currentColor" strokeLinecap="round" strokeWidth="1"/>
            <line id="Ligne_471" dataname="Ligne 471" y1="17.565" x2="12" transform="translate(529 242.5)" fill="none" stroke="currentColor" strokeLinecap="round" strokeWidth="1"/>
          </g>
        </g>
      </g>
    </svg>
  </IconContainer>
)

export default ChartStackedLineIcon